import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    paddingRight: "24px",
  },
  dataGridWrapper: {
    marginTop: "17px",
    backgroundColor: "transparent",
    overflowY: "auto",
    paddingBottom: "40px",
  },

  dataGridWrapperWithFilter: {
    maxHeight: "calc(100vh - 425px)",
  },
}));

export default useStyles;
